import { keymap } from 'prosemirror-keymap';

import { removeFormatting, insertBreak } from '../commands';

const coreKeymap = keymap({
	'Mod-\\': removeFormatting,
	'Shift-Enter': insertBreak,
});

export default coreKeymap;
